import { Box, Container, Grid, Typography } from '@mui/material';

const features = [
  { icon: '🚀', title: 'Employee Onboarding', description: 'Streamline new hire processes with automated workflows, contract generation, and statutory document collection.', color: '#3d7aff' },
  { icon: '📚', title: 'Skills Development', description: 'Track training records, manage WSP/ATR submissions, and monitor SETA compliance with real-time dashboards.', color: '#c9b107' },
  { icon: '⚖️', title: 'Industrial Relations', description: 'Manage disciplinary cases, performance improvement plans, and grievance procedures with guided workflows.', color: '#ef4444' },
  { icon: '📊', title: 'Employment Equity', description: 'Generate EEA2/EEA4 reports, track diversity metrics, and maintain compliance with the EE Act.', color: '#22c55e' },
  { icon: '🏥', title: 'OHS Management', description: 'Track workplace injuries, manage certifications, and maintain OHS calendar events for Annexure 1 compliance.', color: '#f59e0b' },
  { icon: '✅', title: 'Compliance & Audit', description: 'Automated compliance alerts, audit trail, POPIA data management, and regulatory calendar.', color: '#8b5cf6' },
];

export function FeaturesSection() {
  return (
    <Box id="features" sx={{ py: 14, position: 'relative', overflow: 'hidden' }}>
      {/* Star field background */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=1920&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.06,
        }}
      />

      {/* Dot grid overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: 0.06,
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(61,122,255,0.5) 1px, transparent 0)',
          backgroundSize: '40px 40px',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center', mb: 10 }}>
          <Typography sx={{ color: '#6b7a99', fontSize: 14, fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 2 }}>
            Everything You Need
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: 32, md: 48 },
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: '#f0f0f5',
              mb: 2,
            }}
          >
            The Complete HR Toolkit
          </Typography>
          <Typography variant="h6" sx={{ color: '#a0a5b5', maxWidth: 600, mx: 'auto', fontWeight: 400 }}>
            One platform to manage your entire workforce lifecycle.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {features.map((f) => (
            <Grid size={{ xs: 12, md: 4 }} key={f.title}>
              <Box
                sx={{
                  p: 4,
                  height: '100%',
                  borderRadius: 2,
                  border: '1px solid rgba(255,255,255,0.06)',
                  backgroundColor: 'rgba(18, 18, 31, 0.6)',
                  backdropFilter: 'blur(16px)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: `${f.color}40`,
                    transform: 'translateY(-4px)',
                    boxShadow: `0 20px 40px -12px ${f.color}20`,
                  },
                }}
              >
                <Typography sx={{ fontSize: 40, mb: 2 }}>{f.icon}</Typography>
                <Typography variant="h5" sx={{ fontWeight: 600, color: '#f0f0f5', mb: 1, fontSize: 20 }}>
                  {f.title}
                </Typography>
                <Typography variant="body1" sx={{ color: '#a0a5b5', lineHeight: 1.6 }}>
                  {f.description}
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                    height: 2,
                    borderRadius: 2,
                    width: 48,
                    background: `linear-gradient(90deg, ${f.color}80, transparent)`,
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
